<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Redefinição de Senha</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioRedefinicaoSenha" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Senha Atual</mat-label>
                            <input matInput type="password" value="Senha Atual" class="form-control" id="senhaAtual"
                                required trim="blur" name="senhaAtual" formControlName="senhaAtual" maxlength="20">
                            <mat-error *ngIf="formularioRedefinicaoSenha.controls.senhaAtual.hasError('required')">
                                O campo Senha Atual é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Nova Senha</mat-label>
                            <input matInput type="password" value="Nova Senha" class="form-control" id="novaSenha"
                                required trim="blur" name="novaSenha" formControlName="novaSenha" maxlength="20"
                                (input)="onPasswordInput()">
                            <mat-error *ngIf="formularioRedefinicaoSenha.controls.novaSenha.hasError('required')">
                                O campo Nova Senha é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioRedefinicaoSenha.controls.novaSenha.hasError('minlength')">
                                O campo Nova Senha precisa conter no mínimo 6 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Confirmar Nova Senha</mat-label>
                            <input matInput type="password" value="Confirmar Nova Senha" class="form-control"
                                id="confirmarNovaSenha" required trim="blur" name="confirmarNovaSenha"
                                formControlName="confirmarNovaSenha" maxlength="20" (input)="onPasswordInput()">
                            <mat-error
                                *ngIf="formularioRedefinicaoSenha.controls.confirmarNovaSenha.hasError('required')">
                                Por favor confirme a Nova Senha.
                            </mat-error>
                            <mat-error *ngIf="confirmarNovaSenha?.invalid && !confirmarNovaSenha?.hasError('required')">
                                A Nova Senha e sua Confirmação não são iguais.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioRedefinicaoSenha.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>